import theme from '../theme'

function animateCSS (element, animationName, duration, callback)
{
    if (duration == undefined) duration = '1s'

    element.classList.add('animated', animationName)
    element.style.animationDuration = duration

    var parsedDuration = duration

    if (parsedDuration.includes('ms'))
    {
        parsedDuration = parsedDuration.replace('ms', '')
    }
    if (parsedDuration.includes('s'))
    {
        parsedDuration = parsedDuration.replace('s', '')
        parsedDuration = Number.parseFloat(parsedDuration) * 1000
    }

    setTimeout(() =>
    {
        element.classList.remove('animated', animationName)

        if (typeof callback === 'function') callback()
    }, parsedDuration)
}

function getMatchingMediaName ()
{
    if (window.matchMedia(`(min-width: ${theme.properties.screenMdMin})`).matches)
    {
        return 'desktop'
    }
    if (window.matchMedia(`(min-width: ${theme.properties.screenSmMin})`).matches)
    {
        return 'tablet'
    }
    
    return 'mobile'
}

function isSmallMobile ()
{
    return window.matchMedia('only screen and (max-width: 320px) and (max-height: 566px)').matches
}

function isLargeMobile ()
{
    return window.matchMedia('only screen and (min-device-width: 375px) and (min-device-height: 668px) and (max-width: 681px)').matches
}

function getWindowYScroll ()
{
    return window.pageYOffset || 
           document.body.scrollTop ||
           document.documentElement.scrollTop || 0
}

function getDocumentHeight ()
{
    return Math.max(
        document.body.scrollHeight || 0, 
        document.documentElement.scrollHeight || 0,
        document.body.offsetHeight || 0, 
        document.documentElement.offsetHeight || 0,
        document.body.clientHeight || 0, 
        document.documentElement.clientHeight || 0
    )
}

function getScrollDistanceFromDocumentBottom ()
{
    return getDocumentHeight() - (getWindowYScroll() + document.documentElement.clientHeight)
}

function getElementContentRect (element)
{
    const style = window.getComputedStyle(element)
    const rect = element.getBoundingClientRect()

    rect.width -= Number.parseFloat(style.paddingLeft) + Number.parseFloat(style.paddingRight)
    rect.height -= Number.parseFloat(style.paddingTop) + Number.parseFloat(style.paddingBottom)
    
    rect.width -= Number.parseFloat(style.borderLeftWidth) + Number.parseFloat(style.borderRightWidth)
    rect.height -= Number.parseFloat(style.borderTopWidth) + Number.parseFloat(style.borderBottomWidth)

    return rect
}

function setFavicon (url)
{
    var link = document.querySelector('link[rel*="icon"]') || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
}

function isElementVisible (el)
{
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;
  
    while(el.offsetParent)
    {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }
  
    return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
    );
}


const nbsp = '\u00A0'

export default { animateCSS, getMatchingMediaName, isSmallMobile, isLargeMobile, getWindowYScroll, getDocumentHeight, getScrollDistanceFromDocumentBottom, getElementContentRect, setFavicon, nbsp,
    isElementVisible }


// WEBPACK FOOTER //
// ./src/utils/DOMUtils.js